import { Link, useHistory, NavLink } from 'react-router-dom'

import { Input, Menu } from 'antd'

// import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs';

import logo from '@/assets/images/nav/logo.png'
import newPng from '@/assets/images/nav/new.png'

import searchHot from '@/assets/images/nav/search-hot.png'
import searchNew from '@/assets/images/nav/search-new.png'
import change from '@/assets/images/nav/change.png'

import dashuju from '@/assets/images/nav/dashuju.svg'
import dianziquzheng from '@/assets/images/nav/dianziquzheng.svg'
import shujufenxi from '@/assets/images/nav/shujufenxi.svg'
import shujuyunying from '@/assets/images/nav/shujuyunying.svg'
import search from '@/assets/images/nav/search.svg'
import arrowRight from '@/assets/images/nav/arrow-right.svg'
import arrowUp from '@/assets/images/nav/arrow-up.png'
import arrowRightActive from '@/assets/images/nav/arrow-right.png'

import styles from './style.module.scss'
import { useEffect, useState } from 'react';

import { TOOLS } from 'constantss';

// import { urlParams } from 'utils/urlParams';

interface SearchItem {
    name: string;
    icon?: any;
    hot?: boolean;
    new?: boolean;
    key?: string;
    href?: string;
    children?: SearchItem[];
}

const recommendList: SearchItem[] = [
    {
        name: '热门产品',
        children: [
            {
                name: 'FH FitACE-低代码开发平台',
                hot: true,
                new: false,
                href: TOOLS.ACE_URL
            },
            {
                name: 'FH FitBOSS-数据可视化平台',
                hot: true,
                new: false,
                href: TOOLS.BOSS_URL
            },
            {
                name: 'FH FitBI-商业智能工具',
                hot: false,
                new: false,
                href: TOOLS.BI_URL
            },
            {
                name: 'FH FDP-数据迁移工具',
                hot: false,
                new: false,
                href: TOOLS.FDP_URL
            }
        ]
    },
    {
        name: '新品发布',
        children: [
            {
                name: 'FH FitACE-低代码开发平台',
                hot: false,
                new: true,
                href: TOOLS.ACE_URL
            },
            {
                name: 'FH FitBOSS-数据可视化平台',
                hot: false,
                new: false,
                href: TOOLS.BOSS_URL
            },
            {
                name: 'FH FitBI-商业智能工具',
                hot: false,
                new: false,
                href: TOOLS.BI_URL
            },
            {
                name: 'FH FDP-数据迁移工具',
                hot: false,
                new: false,
                href: TOOLS.FDP_URL
            }
        ]
    },
    {
        name: '产品动态',
        children: [
            {
                name: 'FH FitACE-低代码开发平台动态',
                hot: false,
                new: false,
                href: TOOLS.ACE_URL
            },
            {
                name: 'FH FitBOSS-数据可视化平台动态',
                hot: false,
                new: false,
                href: TOOLS.BOSS_URL
            },
            {
                name: 'FH FitBI-商业智能工具最新动态',
                hot: false,
                new: false,
                href: TOOLS.BI_URL
            },
            {
                name: 'FH FDP-数据迁移工具最新动态',
                hot: false,
                new: false,
                href: TOOLS.FDP_URL
            }
        ]
    }
];

const allList: SearchItem[] = [
    {
        name: '大数据智能化产品',
        icon: dashuju,
        children: [
            {
                name: '大数据平台',
                href: '/production?module=BigDataPlatform'
            },
            {
                name: '数据治理工具',
                href: '/production?module=DataGovernanceTools'
            },
            {
                name: '分析建模工具',
                href: '/production?module=AnalyticalModelingTools'
            },
            {
                name: '应用开发工具',
                href: TOOLS.URL
            }
        ]
    },
    {
        name: '电子取证产品',
        icon: dianziquzheng,
        children: [
            {
                name: '“烽”系列',
                href: '/production?module=FengSeries'
            },
            {
                name: '“鹰”系列',
                href: '/production?module=YingSeries'
            },
            {
                name: '综合取证系列',
                href: '/production?module=ComprehensiveForensicsSeries'
            },
            {
                name: '取证分析系列',
                href: '/production?module=ForensicAnalysisSeries'
            }
        ]
    },
    {
        name: '数据分析服务',
        icon: shujufenxi,
        children: [
            {
                name: '数据分析服务',
                href: '/production?module=DataAnalysisService'
            },
        ]
    },
    {
        name: '数据运营服务',
        icon: shujuyunying,
        children: [
            {
                name: '数据运营服务',
                href: '/production?module=DataOperationService'
            },
        ]
    }
];

export const Nav = (props) => {

    const { isScroll, isShowWebsite } = props;

    const [activeKey, setActiveKey] = useState('/');

    const [showSearchWrapper, setShowSearchWrapper] = useState(false);

    const [searchResults, setSearchResults] = useState<SearchItem[]>([]);

    const [activeLi, setActiveLi] = useState('recom');

    const history = useHistory();

    const items = [
        {
            label: (<NavLink to="/" activeClassName='active' exact>首页</NavLink>),
            key: '/'
        },
        {
            label: (<NavLink to="/production" activeClassName='active' exact onMouseEnter={() => { setShowSearchWrapper(true) }} onMouseLeave={() => { setShowSearchWrapper(false) }}>产品及服务</NavLink>),
            key: '/production',
            children: [
                {
                    label: (<Link to="/production?type=BigData">大数据智能化产品</Link>),
                    key: '/production?type=BigData'
                },
                {
                    label: (<Link to="/production?type=ElectronicForensicsProducts">电子取证产品<img src={newPng} alt="" /></Link>),
                    key: '/production?type=ElectronicForensicsProducts'
                },
                {
                    label: (<Link to="/production?type=DataAnalysisService">数据分析服务</Link>),
                    key: '/production?type=DataAnalysisService'
                },
                {
                    label: (<Link to="/production?type=DataOperationService">数据运营服务</Link>),
                    key: '/production?type=DataOperationService'
                }
            ]
        },
        {
            label: (<NavLink to="/solution" activeClassName='active' exact>解决方案</NavLink>),
            key: '/solution',
            children: [
                {
                    label: (<Link to="/solution?module=NetworkSafety" >网络安全</Link>),
                    key: '/solution?module=NetworkSafety'
                },
                {
                    label: (<Link to="/solution?module=SmartPolicing" >智慧警务</Link>),
                    key: '/solution?module=SmartPolicing'
                },
                {
                    label: (<Link to="/solution?module=SmartGovernment" >智慧政务</Link>),
                    key: '/solution?module=SmartGovernment'
                },
                {
                    label: (<Link to="/solution?module=SmartCommunity" >智慧社区</Link>),
                    key: '/solution?module=SmartCommunity'
                },
                {
                    label: (<Link to="/solution?module=SmartComprehensiveInsurance" >智慧综保</Link>),
                    key: '/solution?module=SmartComprehensiveInsurance'
                },
                // {
                //     label: (<Link to="/solution?module=SmartAntiSmuggling" >智慧缉私</Link>),
                //     key: '/solution?module=SmartAntiSmuggling'
                // },
                {
                    label: (<Link to="/solution?module=DigitalTransformation">企业数字化转型<img src={newPng} alt="" /></Link>),
                    key: '/solution?module=DigitalTransformation'
                }
            ]
        },
        {
            label: (<NavLink to="/support" activeClassName='active'>服务体系</NavLink>),
            key: '/support'
        },
        {
            label: (<NavLink to="/about" activeClassName='active'>关于星空</NavLink>),
            key: '/about'
        },
    ];

    useEffect(() => {
        getActiveKey();
    }, []);

    useEffect(() => {
        const unlisten = history.listen((historyLocation) => {
            getActiveKey();
        })
        return () => {
            unlisten();
        }
    }, [history]);

    const getActiveKey = () => {
        const pathname = window.location.pathname
        let key = window.location.pathname;
        if (window.location.search) {
            key = `${pathname}${window.location.search}`;
        }
        setActiveKey(key);
    }

    useEffect(() => {
        // 监听页面滚动
        document.addEventListener('scroll', onScroll);

        return () => document.removeEventListener('scroll', onScroll);
    }, []);

    const onScroll = () => {
        // 距顶部
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        // 可视区高度
        // const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
        // 滚动条总高度
        // const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

        if (scrollTop > 64) {
            props.onScroll(true);
        } else {
            props.onScroll(false);
        }
    }

    const changeShowWebsite = (flag) => {
        props.changeShowWebsite(flag);
    }

    const onSearch = (e) => {
        const { target } = e;
        const searchText = target.value;
        console.log(searchText, 'lll')
        if (searchText && searchText.trim().length > 0) {
            const results = findObjects(allList, searchText.trim());
            setSearchResults(results);
        } else {
            setSearchResults([]);
        }
    }

    const findObjects = (data: SearchItem[], name: string): SearchItem[] => {
        const results: SearchItem[] = [];

        function traverse(obj: SearchItem): void {
            if (obj.name.includes(name)) {
                results.push(obj);
            }

            if (obj.children) {
                obj.children.forEach(child => traverse(child));
            }
        }

        data.forEach(item => traverse(item));
        return results;
    }

    const go = (href) => {
        window.open(href, '_blank');
    }

    return (
        <header>
            {/* <div className={styles['website-wrapper']}>
                <span onClick={() => changeShowWebsite(!isShowWebsite)}> <img src={change} alt="" />烽火网站<img className={`${isShowWebsite ? styles['down'] : ''}`} src={arrowUp} alt="" width={10} /></span>
            </div> */}
            <div className={`${styles['website-container']} ${isShowWebsite ? styles['show'] : ''}`}>
                <div className={styles['website-fh']}>
                    <p className={styles['website-title']}><img src={arrowRightActive} alt="" />烽火网站</p>
                    <p className={styles['website-desc']}>一站式行业应用开发、数据洞察解决方案</p>
                </div>
                <div className={styles['website-tool']} onClick={() => { go(TOOLS.URL) }}>
                    <p className={styles['website-title']}>应用开发工具集网站<i className={styles['arrow-right']} /></p>
                    <p className={styles['website-desc']}>一站式应用工具集</p>
                </div>
            </div>
            <nav className={`${styles['nav']} ${isScroll ? styles['isFixed'] : ''} ${isShowWebsite ? styles['transform-down'] : ''} ${showSearchWrapper ? styles['white'] : ''}`}>
                <Link to="/"><img src={logo} alt="烽火星空" /></Link>
                <Menu
                    mode="horizontal"
                    activeKey={activeKey}
                    items={items}
                />
            </nav>
            {/* <div
                className={`${styles['search-wrapper']} ${showSearchWrapper ? styles['show'] : ''} ${isShowWebsite ? styles['transform-down'] : ''}`}
                onMouseEnter={() => { setShowSearchWrapper(true) }}
                onMouseLeave={() => { setShowSearchWrapper(false) }}
            >
                <div className={styles['search-left']}>
                    <Input placeholder='搜索产品和服务' suffix={<img src={search} alt='' width={12} />} onChange={onSearch} allowClear />
                    <ul>
                        <li className={`${activeLi === 'recom' ? styles['active'] : ''}`} onClick={() => setActiveLi('recom')}>热门推荐<img src={arrowRight} alt='' /></li>
                        <li className={`${activeLi === 'all' ? styles['active'] : ''}`} onClick={() => setActiveLi('all')}>全部产品及服务<img src={arrowRight} alt='' /></li>
                    </ul>
                </div>
                <div className={styles['search-right']}>
                    {searchResults.length > 0 ? (<div className={styles['result-wrapper']}>
                        <div className={styles['result-title']}>搜索结果</div>
                        {searchResults.map((reuslt, index) => (
                            <p onClick={() => { go(reuslt.href) }} key={index}>{reuslt.name}</p>
                        ))}
                    </div>) :
                        activeLi === 'recom' ? (<div className={styles['recom-wrapper']}> {
                            recommendList.map((value, index) => (
                                <div className={styles['recom-item']} key={index}>
                                    <div className={styles['recom-title']}>{value.name}</div >
                                    {value.children && value.children.map(child => (<p onClick={() => { go(child.href) }} key={child.name}>{child.name}{child.hot && <img src={searchHot} alt='' />}{child.new && <img src={searchNew} alt='' />}</p>))}
                                </div>
                            ))
                        }
                        </div>) : (<div className={styles['all-wrapper']}>
                            {allList.map((value, index) => (
                                <div className={styles['all-item']} key={index}>
                                    <div className={styles['all-title']}>
                                        <img src={value.icon} alt='' />
                                        {value.name}
                                    </div>
                                    {value.children && value.children.map(child => (<p onClick={() => { go(child.href) }} key={child.name}>{child.name}</p>))}
                                </div>
                            ))}
                        </div>)
                    }
                </div>
            </div> */}
        </header>
    );
}
